import React, { useState } from 'react';
import { Create } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';

import NavigationPrompt from '../../core/components/NavigationPrompt';
import CreateToolbar from '../../core/components/CreateToolbar';
import FormTitleBar from '../../core/components/FormTitleBar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import DocumentTypeSummary from './DocumentTypeSummary';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const DocumentTypeTitle = () => {
  return (
    <FormTitleBar
      creation={true}
      showAvatar={true}
      avatarContent="DT"
      recordLabel="Document Type"
    />
  );
};

const DocumentTypeCreate = props => {
  const [whenBlockNavigation, setWhenBlockNavigation] = useState(false);

  const {
    classes,
    userProfile,
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    ...rest
  } = props;
  return (
    <React.Fragment>
      <NavigationPrompt when={whenBlockNavigation} creation>
        {(isOpen, onConfirm, onCancel) => (
          <LeaveConfirm
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onCancel}
          />
        )}
      </NavigationPrompt>
      <Create
        {...rest}
        record={{
          description: ''
        }}
        title={<DocumentTypeTitle />}
        classes={{
          noActions: classes.noActions
        }}
      >
        <CustomSimpleForm
          toolbar={
            <CreateToolbar
              allowNavigationOnSave={() => setWhenBlockNavigation(false)}
            />
          }
          variant="standard"
          margin="normal"
        >
          <DocumentTypeSummary />
          <FormSpy
            subscription={{
              dirty: true
            }}
            onChange={props => {
              props.dirty && setWhenBlockNavigation(props.dirty);
            }}
          />
        </CustomSimpleForm>
      </Create>
    </React.Fragment>
  );
};

export default withStyles(styles)(DocumentTypeCreate);
